<template>
	<b-modal
		size="xmd"
		ref="specimen-temperaments-tracking-modal"
		@hidden="$emit('close')"
		ok-title="Guardar"
		:title="`Tracking de Temperamentos de ${specimen.plate} ${specimen.alias ? '(' + specimen.alias + ')' : ''}`"
		centered
		no-close-on-backdrop
		hide-footer
	>
		<b-table-simple>
			<b-thead class="text-center">
				<b-tr>
					<b-th>Temperamento</b-th>
					<b-th>Actualizado por</b-th>
					<b-th>Fecha</b-th>
				</b-tr>
			</b-thead>
			<b-tbody class="text-center">
				<b-tr v-for="row in rows" :key="row.id">
					<b-td>{{ row.temperament_name }}</b-td>
					<b-td>{{ row.user_name }}</b-td>
					<b-td>
						{{ row.created_at | myGlobalDayWithHour }}
					</b-td>
				</b-tr>
				<b-tr v-if="rows.length == 0">
					<b-td colspan="3">
						<p class="mb-0">No hay registros por mostrar</p>
					</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</b-modal>
</template>

<script>
import TemperamentService from "@/views/brain/specimens/views/temperaments/services/temperament.service.js"
export default {
	props: {
		specimen: Object,
	},
	name: "SpecimenTemperamentsTrackingModal",
	components: {},
	async mounted() {
		await this.getSpecimenTracking()
		this.$refs["specimen-temperaments-tracking-modal"].toggle()
	},
	data() {
		return {
			rows: [],
		}
	},

	methods: {
		async getSpecimenTracking() {
			this.isPreloading()
			try {
				const { data } = await TemperamentService.getSpecimenTemperamentTracking(this.specimen.id)
				this.rows = data
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
	},
}
</script>

<style></style>
